const canBeMovedForward = (element) =>
  !!element.nextElementSibling && element.tagName === element.nextElementSibling.tagName;

export default canBeMovedForward;
